import { Parcel } from "../../../model/parcel";
import React from "react";
import { notificationModel } from "../../../../common/component/notifications/notification-model";
import { AnnounceParcelTrackerMultiStepForm } from "./announce-parcel-tracker-multi-step-form";
import { ParcelAnnounceTrackerCommand } from "../../../../common/cqrs/command/parcel-announce-tracker/parcel-announce-tracker-command";
import { ParcelAnnounceTrackerHandler } from "../../../../common/cqrs/command/parcel-announce-tracker/parcel-announce-tracker-handler";
import { useAnnounceParcelTrackerContext } from "./announce-parcel-tracker-context";
import { AnnounceParcelTrackerSingleForm } from "./announce-parcel-tracker-single-form";
import { t } from "i18next";

interface IAnnounceParcelTrackerAssignmentProps {
    parcel: Parcel;
    parcelCount: number;
    remainingParcelCount: number;
    onFormSubmit: () => void;
    onSkip: () => void;
    onCancel: () => void;
}

export const AnnounceParcelTrackerForm = (props: IAnnounceParcelTrackerAssignmentProps) => {
    const { setCarrier } = useAnnounceParcelTrackerContext();

    const handleParcelTrackerAnnouncement = async (carrier: string, tracker: string) => {
        try {
            const parcel = await ParcelAnnounceTrackerHandler(new ParcelAnnounceTrackerCommand(props.parcel, carrier, tracker));

            notificationModel.addSuccessMessage(t("components.parcel.btmAssignTracker.notification.success", {
                parcel: parcel.id,
                tracker,
            }));
            setCarrier(carrier);
            props.onFormSubmit();
        } catch (err) {
            notificationModel.addErrorMessage("components.parcel.btmAssignTracker.notification.error");
        }
    };

    return props.parcelCount === 1 ?
        <AnnounceParcelTrackerSingleForm parcel={props.parcel}
                                         onSubmit={handleParcelTrackerAnnouncement}
                                         onCancel={props.onCancel} /> :
        <AnnounceParcelTrackerMultiStepForm parcel={props.parcel}
                                            onSubmit={handleParcelTrackerAnnouncement}
                                            remainingParcelCount={props.remainingParcelCount}
                                            onSkip={props.onSkip}
                                            onCancel={props.onCancel} />;
};
